import { ILopTinChiKetQuaActionTypes } from "../../action-types/lop-tin-chi/ILopTinChiKetQuaActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ILopTinChiKetQuaReducer } from "../../reducer-model/lop-tin-chi/ILopTinChiKetQuaReducer";
const iniState: ILopTinChiKetQuaReducer = {
    status: eReducerStatusBase.is_not_initialization,
    lopTinChis: [],
    filter: {
        hoc_ky: 0,
        nam_hoc: "",
        id_chuyen_nganh: 0,
        id_he: 0,
        khoa_hoc: 0,
        ky_dang_ky: 0,
        stu_nhomlop_id: 0
    },
    selectedIds: [],
    lopTinChiIdView: 0
}
export const lopTinChiKetQuaReducer = (state: ILopTinChiKetQuaReducer = iniState, actions: ILopTinChiKetQuaActionTypes): ILopTinChiKetQuaReducer => {
    switch (actions.type) {

        case "LOP_TIN_CHI_KET_QUA_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "LOP_TIN_CHI_KET_QUA_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                lopTinChis: actions.payload
            }
        case "LOP_TIN_CHI_KET_QUA_LOAD_ERRR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "LOP_TIN_CHI_KET_QUA_CHANGE_FILTER":
            return {
                ...state,
                filter: actions.payload
            }
        case "LOP_TIN_CHI_KET_QUA_CHANGE_SELECTED_IDS":
            return {
                ...state,
                selectedIds: actions.payload
            }
        case "LOP_TIN_CHI_KET_QUA_CHANGE_LOPTINCHI_ID_VIEW":
            return {
                ...state,
                lopTinChiIdView: actions.payload
            }
        default:
            return state;
    }
}